import { LinearProgressWithLabel } from '@/components/LinearProgressWithLabel'
import { useAppContext } from '@/hooks'
import { ConfirmationOptions } from '@/pages/App/types'

interface ConfirmationDialogDescriptionProps {
	confirmationState: ConfirmationOptions | null
	isProcessingStarted: boolean
}

export const ConfirmationDialogDescription = ({
	confirmationState,
	isProcessingStarted,
}: ConfirmationDialogDescriptionProps) => {
	const { t } = useAppContext()

	const getConfirmStateMessage = () => {
		if (!confirmationState) {
			return t('NO_CONFIRMATION_STATE')
		}

		return confirmationState?.description
	}

	return (
		<div className="w-full">
			<div>{getConfirmStateMessage()}</div>

			{isProcessingStarted && confirmationState?.isAsync && (
				<LinearProgressWithLabel value={confirmationState?.progress ?? 0} />
			)}
		</div>
	)
}
